import * as React from 'react';
import { motion, AnimatePresence } from 'framer-motion';


interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  show?: any;
}


/**
 * ClamShell: a component that renders its children in/out with an expanding/collapsing animation.
 * If you want to add margin to the clamshell component, you'll want to wrap the children you're giving it in another
 * div, and give padding to that div. Margin doesn't animate well, unfortunately.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const ClamShell: React.FC<Props> = props => {
  const { show, ...rest } = props;

  return (
    <AnimatePresence>
      {
        !!props.show && (
          <motion.div
            key='clam_shell_content'
            initial={{ height: 0, overflow: 'hidden' }}
            animate={{ height: 'auto', overflow: 'hidden' }}
            exit={{ height: 0, overflow: 'hidden' }}
            transition={{ duration: 0.6, ease: [0.04, 0.62, 0.23, 0.98] }}
            {...rest as any}
          />
        )
      }
    </AnimatePresence>
  );
};

export default ClamShell;
